import { DetailButton } from "./DetailButton";
import { DownloadButton } from "./DownloadButton";

export const RowActions = (id: string) => {
  return [<DetailButton id={id} />, <DownloadButton id={id} />];
};
